import {
  IntegrationType,
  PLATFORM_TYPE,
  PROCESSOR,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { retailerSettingsManager } from '../../../../ng-compat/managers'
import { LSPAY_DATADOG_CLIENT_TOKEN } from './lspayConstants'

export const getMonitoringInstance = (
  outletId: string,
  isSandbox: boolean,
  integrationType: IntegrationType
) => {
  const instance = TerminalEventMonitoring.init({
    clientToken: LSPAY_DATADOG_CLIENT_TOKEN,
    env: isSandbox ? 'stage' : 'prod',
    product: 'x-series',
    pli: getPli(outletId),
    processor: PROCESSOR.STRIPE,
    integrationType,
    platformType: PLATFORM_TYPE.WEB,
    service: 'webregister',
    verbose: isSandbox,
  })

  const retailerId = retailerSettingsManager?.get()?.id
  if (retailerId) {
    instance.setPersistentAttributes({ retailerId })
  }

  return instance
}

const getPli = (outletId: string): string => {
  return 'lsx:' + outletId
}
